import { render, staticRenderFns } from "./subarea.vue?vue&type=template&id=aec71f24"
import script from "./subarea.vue?vue&type=script&lang=js"
export * from "./subarea.vue?vue&type=script&lang=js"
import style0 from "./subarea.vue?vue&type=style&index=0&id=aec71f24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports